import React, { useState } from "react";
import { Container, Dropdown, Button } from "react-bootstrap";
import Table from "./components/Table";
import axios from "../../api/axios";
import useAuth from "../../hooks/useAuth";
import Navbar from "../../components/Navbar";

const User = () => {

  const DAIRIES_URL = "/dairies";
  const { auth } = useAuth();
  const [data, setData] = useState([]);
  const [title, setTitle] = useState('Tambos')
  const [loading, isLoading] = useState(true)
  const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
  const currentDate = new Date()
  const [currentMonth, setCurrentMonth] = React.useState(currentDate.getMonth() + 1)
  const [currentYear, setCurrentYear] = React.useState(currentDate.getFullYear())
  const [selectedValues, setSelectedValues] = React.useState([])
  const years = [...new Set([
    currentDate.getFullYear(),
    ...data.map((item) => item.anio),
  ])].sort((firstYear, secondYear) => secondYear - firstYear)

  React.useEffect(() => {
    const selected = data.filter((item) => (
      item.mes === currentMonth && item.anio === currentYear
    ))
    setSelectedValues(selected)
  }, [data, currentMonth, currentYear])


  const getUsers = async () => {
    try {
      const response = await axios.get(
        DAIRIES_URL,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: 'Bearer ' + auth?.accessToken,
          },
        }
      );
      // TODO: remove console.logs before deployment
      const format = response?.data.reduce((newFormat, value) => {
        const [year, month] = String(value.fecha).slice(0, 10).split("-")
        return [...newFormat, { ...value, mes: Number(month), anio: Number(year) }]
      }, [])
      setData(format.sort((a, b) => {
        return String(a.fecha).slice(0, 10).localeCompare(String(b.fecha).slice(0, 10));
      }))
      isLoading(false)
      if (response?.data.length > 0) {
        setTitle(response.data[0].nombre_tambo)
      }
    } catch (err) {
      console.error(err);
    }
  }





  return (
    <Container>
      <Navbar />
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1 className="h2">{title}</h1>
      </div>
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <div className="d-flex gap-2">
          <Dropdown onSelect={(eventKey) => setCurrentMonth(Number(eventKey))}
          value={currentMonth}>
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            {meses[currentMonth - 1]}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {meses.map((mes, key) => (
              <Dropdown.Item eventKey={key + 1} key={key} active={key + 1 === currentMonth}>
                {mes}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
          </Dropdown>
          <Dropdown onSelect={(eventKey) => setCurrentYear(Number(eventKey))} value={currentYear}>
            <Dropdown.Toggle variant="success" id="year-dropdown">
              {currentYear}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {years.map((year) => (
                <Dropdown.Item eventKey={year} key={year} active={year === currentYear}>
                  {year}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <Button variant="success" onClick={() => {
          setSelectedValues(data)
        }}>Eliminar filtros de fecha</Button>
      </div>

      <Table refresh={getUsers} axiosData={selectedValues} loadingData={loading} />

    </Container>
  );
};

export default User;
